import Home from "./Pages/Home";
import Contact from "./Pages/Contactus";
import ServiceFacade from "./Pages/ServiceFacade";
import ServiceDeep from "./Pages/ServiceDeep";
import ServiceDiamondMarvel from "./Pages/ServiceDiamondMarvel";
import ServiceSofaDry from "./Pages/ServiceSofaDry"
import ServiceWhiteWash from "./Pages/ServiceWhitewash"
import PestControl from "./Pages/ServicePestControl"
import Aboutus from "./Pages/Aboutus";


export const routes = [
    {
        name: "Home",
        path: "/home",
        element: <Home />,
        submenu: null
    },
    {
        name: "About",
        path: "/about",
        element: <Aboutus />,
        submenu: null
    },
    {
        name: "Services",
        path: null,
        element: null,
        submenu: [
            {
                name: "Facade Cleaning",
                path: "/servicefacade",
                element: <ServiceFacade />
            },
            {
                name: "Deep Cleaning",
                path: "/servicedeep",
                element: <ServiceDeep />
            },
            {
                name: "Diamond Marble Floor Polish",
                path: "/servicediamond",
                element: <ServiceDiamondMarvel />
            },
            {
                name: "Carpet / Sofa Dry Cleaning",
                path: "/servicesofadry",
                element: <ServiceSofaDry />
            },
            {
                name: "White Wash Paint Work",
                path: "/servicewhitewash",
                element: <ServiceWhiteWash />
            },
            {
                name: "Pest Control",
                path: "/pestcontrol",
                element: <PestControl />
            },
        ]
    },
    {
        name: "Projects",
        path: "/contact",
        element: <Contact />,
        submenu: null
    },
    {
        name: "Contact",
        path: "/contact",
        element: <Contact />,
        submenu: null
    }
];
export default routes;